import { LabelMasterStatusEnum } from '@ulysses-inc/harami_api_client'

/** ラベルマスタのステータスをUI向けの文言に対応づける */
export const labelMasterStatusText: Record<LabelMasterStatusEnum, string> = {
  [LabelMasterStatusEnum.VALID]: '表示',
  [LabelMasterStatusEnum.INVALID]: '非表示',
}
